/**
 * 懒加载
 */
import React from 'react';
//react 版本17》生命周期名称改为 UNSAFE_componentWillMount
import Loadable from 'react-loadable';
import { Modal, Spin } from 'antd';
import NotFound from '../components/NotFound/index'
//默认配置
export const defaultsetting = {
  timeout: 10000,
  delay: 300
};

export const loadable = ( loaders ) => {
  return Loadable( {
    loader: loaders.loader,
    delay: loaders.loadering ? loaders.loadering.delay ? loaders.loadering.delay : 10000 : 10000,
    timeout: loaders.loadering ? loaders.loadering.timeout ? loaders.loadering.timeout : 300 : 300,
    loading: Loading,
  } );
};

export default loadable;

let timer = true
function Loading ( props ) {
  const isRefresh = sessionStorage.getItem('isRefresh')
  if ( props.error ) {
    /* 
    {
      "isLoading": false,
      "pastDelay": false,
      "timedOut": false,
      "error": {
        "message": "Loading chunk 106 failed.\n(missing: http://192.168.100.75:81/static/js/106.f89f8624.chunk.js)",
        "name": "ChunkLoadError",
        "type": "missing",
        "request": "http://192.168.100.75:81/static/js/106.f89f8624.chunk.js"
      }
    } 
    */
    console.log('loadableErr', props)
    /* 
      由于我们的路由采用的是按需加载策略
      若刚好在用户使用时更新了项目，由于用户访问的是旧版本的index.html,所以请求路径是会访问旧的 name.hash.chunk.js 文件，
      但我们采用的是替换更新，旧的文件找不到，就会报 ChunkLoadError 错误，所以这里提示用户刷新浏览器
    */
    
    if (props.error.name === 'ChunkLoadError' && isRefresh === 'false') { // isRefresh 已经刷新过仍显示error 的显示404页面，避免一直刷新
      if (timer) {
        timer = false
        const config = {
          title: '发现新版本', 
          content: (
            <>
            <p>检测到新版本，即将进行更新...</p>
            </>
          ),
          onOk() {
            sessionStorage.setItem('isRefresh', true)
            window.location.reload()
          }
        }
        Modal.info(config)
        return (
          <></>
        )
      }
    } 
    return (<NotFound NotFoundmode={ 'Error' }/>)
  }
  else if ( props.timedOut ) {
    return (
      <div style={ {
        width: '100%',
        height: '50rem',
        textAlign: 'center',
        position: 'relative',
        lineHeight: '50rem',
        zIndex: 100,
      } }>
        <Spin tip="Loading..." size="large"/>
      </div>
    );
  }
  else if ( props.pastDelay ) {
    return (
      <div style={ {
        width: '100%',
        height: '50rem',
        textAlign: 'center',
        position: 'relative',
        lineHeight: '50rem',
        zIndex: 100,
      } }>
        <Spin tip="超时，请刷新..." size="large"/>
      </div>
    )
  }
  else {
    sessionStorage.setItem('isRefresh', false)
    return (
      <></>
    )
  }
}